// removed by extract-text-webpack-plugin
module.exports = {"subline":"_3sEKs"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.scss
// module id = GKcl
// module chunks = 0